import { useCallback } from 'react';
import useSubscriptions from '@afosto/utils-react/subscription/useSubscriptions';
import useLocalStorage from '@afosto/utils-react/useLocalStorage';

const usePrintSettings = () => {
  const [getLocalStorage] = useLocalStorage();
  const subscriptions = useSubscriptions();
  const hasSpoolerSubscription = subscriptions.some(({ code: appCode }) => appCode === 'spl');

  const getPrintSettings = useCallback(
    (hubSettingKey, printerSettingKey) => {
      const hubID = getLocalStorage(hubSettingKey);
      const printerID = getLocalStorage(printerSettingKey);
      const isConfigured = printerID && hubID;

      return { isConfigured, hubID, printerID };
    },
    [getLocalStorage],
  );

  return {
    canPrint: hasSpoolerSubscription,
    getPrintSettings,
  };
};

export default usePrintSettings;
